module.exports = {
	// 首页
	inbox: "Inbox",
	drafts: "Drafts",
	sendItems: "Sent Items",
	deletedItems: "Deleted Items",
	junkEmail: "Junk Email",
	newMail: "New Mail",
	newMeeting: "New Meeting",
	catalog: "Catalog",
	mailType: "Type",
	unread: "Unread",
	total: "Total",
	from: "From",
	to: "To",
	cc: "Cc",
	subject: "Subject",
	all: "All",
	starred: "Starred",
	noStar: "No star",
	receiptTime: "Receipt Time",
	sendTime: "Send Time",
	createTime: "Create Time",
	time: "Time",
	reply: "Reply",
	replyAll: "Reply All",
	forward: "Forward",
	delete: "Delete",
	deleteCompletely: "Delete Completely",
	delConfirm: "Delete Confirmation",
	delUnableRecover: "Mail will be unable to recover after thorough deletion. Are you sure you want to delete it?",
	setAsRead: "Mark As Read",
	setAsUnread: "Mark As Unread",
	previousPage: "Previous",
	nextPage: "Next",
	Page: "Page",
	markAsRead: "Mark As Read",
	markAsUnread: "Mark As Unread",
	markAsJunkEmail: "Mark As Junk Email",
	markAsStar: "Mark As Star",
	closePreviewWindow: "Close Preview Window",
	hideFullInformation: "Hide Full Information",
	displayFullInformation: "Display Full Information",
	upAndDown: "Up And Down",
	leftAndRight: "Left And Right",
	exit: "Exit",
	refresh: "Refresh",
	enterMailbox: "Enter Mailbox",
	enterMail: "Enter Mail",
	enterCalendar: "Enter Calendar",
	enterBPM: "Enter BPM",
	enterTheContent: "Enter The Content",
	advancedSearch: "Advanced Search",
	emptyFolder: "Empty Folder",
	markAllAsRead: "Mark All As Read",
	viewUnread: "View Unread",
	createNewFolder: "Create New Folder",
	rename: "Rename",
	foldername: "Foldername",
	renameFolderName: "Rename Folder Name",
	meetingSelectCondition: "Meeting the selected conditions",
	subjectContains: "Subject Contains",
	senderContains: "Sender Contains",
	performFllowOperations: "Perform the following operations",
	moveTo: "Move To",
	pleaseInputEmailAddress: "Please input the email address",
	saveSuccess: "Successfully Saved",
	delSuccess: "Successfully Deleted",
	pleaseEnterFolderName: "Please enter the folder name",
	createRules: "Create Rules",
	read: "Read",
	previousMail: "Previous",
	nextMail: "Next",
	download: "Download",
	downloadAll: "Download All",
	editDraft: "Edit Draft",
	trackMail: "Track Mail",
	selectWantViewMail: "Select the email you want to view",
	noMail: "No Mail",
	attendees: "Attendees",
	attachments: "Attachments",
	clickDelMmail: "Click to delete the mail",
	starMail: "Star Mail",
	attaMail: "Mail With Attachments",
	cancelStar: "Cancel Star",
	cancelSuc: "Cancellation of success",
	cancelFail: "Cancel failure",
	markUnjunkMail: "Marked As Unjunk Mail",
	send: "Send",
	isUpdateDraft: " Do you want to save the updated draft?",
	mailTrack: "Mail Tracking",
	trackList: "Tracking List",
	readState: "Reading State",
	readTime: "Reading Time",
	open: "Open",
	// 高级搜索
	startTime: "Start",
	endTime: "End",
	optionDate: "Option Date",
	optionTime: "Option Time",
	folder: "Folder",
	noRestrictions: "No Restrictions",
	includeAttachments: "Include Attachments",
	excludeAttachments: "Exclude Attachments",
	search: "Search",
	cancel: "Cancel",
	// 写信
	addAttachment: "Add Attachment",
	singleAttaMax: "Maximum 50M for a single attachment",
	saveDraft: "Save",
	timing: "Timing",
	mailWillRecipientAtXXX: "This email will be delivered to the recipient at XXX",
	emaiWillToMailbox: "The time when this email will be delivered to the other party's mailbox：",
	discard: "Discard",
	setImportance: "Set Importance",
	high: "High",
	normal: "Normal",
	readReceipt: "Request a read receipt",
	organization: "Organization",
	frequentContacts: "Frequent Contacts",
	organizationFramework: "Organization",
	name: "Name",
	position: "Position",
	email: "Email",
	operation: "Operation",
	noPerpsonInfo: "Sorry,no relevant personnel information was found",
	searchNameAndEnter: "Please enter the user name you want to search, and press enter to search",
	createGroup: "Create A Group",
	editGroup: "Edit The Group",
	delGroup: "Delete The Group",
	groupMembers: "Group Members",
	noMember: "No Member",
	delToFrequentContacts: "Delete",
	addToFrequentContacts: "Add To Frequent Contacts",
	groupName: "Group Name",
	enterGroupName: "Please enter the group name",
	confirm: "Confirm",
	PleaseAddRecipients: "Please add recipients",
	tips: "Tips",
	isSaveDraft: "Whether to save as draft？",
	addressBook: "Address Book",
	groupSet: "Group Setup",
	yes: "Yes",
	no: "No",
	// 新建会议
	location: "Location",
	addMeetingLocation: "Add Meeting Location",
	reminder: "Reminder",
	sendMeetingMail: "Send Conference Emails",
	pleaseAddAttendees: "Add Attendees",
	pleaseAddMeetingLocation: "Add Meeting Location",
	pleaseSelect: "Please Choose",
	choseRoom: "Choose Room",
	choseRoomList: "Choose Room List",
	noFreeRoom: "No Free Room",
	findFreeRoom: "Find Free Rooms",
	free: "Free",
	// 查看日历
	month: "Month",
	today: "Today",
	Sunday: "Sunday",
	Monday: "Monday",
	Tuesday: "Tuesday",
	Wednesday: "Wednesday",
	Thursday: "Thursday",
	Friday: "Friday",
	Saturday: "Saturday",
	response: "Response",
	accept: "Accept",
	tentative: "Tentative",
	decline: "Decline",
	jujue: "Decline",
	editReplyBeforeSending: "Edit Reply Before Sending",
	sendReplyImmediately: "Send Reply Immediately",
	noReply: "No Reply",
	meetingTime: "when",
	organizer: "Organizer",
	allowSeeFullInfo: "Allow the other party to view the full details",
	allowSeeLimitInfo: "Allow the other party to view limited details",
	allowSeeOnlyFeasibility: "Allow the other party to see only feasibility",
	start: "Start",
	end: "End",
	noPlace: "No place",
	notYetAcceptMeeting: "The meeting has not yet been accepted.",
	// 提示语
	thankPraisePower: "Thank you for your praise, your satisfaction is our greatest motivation",
	receivedFeedbackFutureOptimi: "We have received your feedback and will be optimized in the future",
	mailboxAdded: "The mailbox has been added",
	inputCorrectEmail: "Please input the correct email address",
	selectFolder: "Please select a folder",
	moveSuccess: "Move successfully",
	moveFailure: "Move failed",
	enterSearchContent: "Enter search content",
	resetRuleSuccess: "Reset rule succeeded",
	resetRuleFailure: "Reset rule failed",
	cancelResetRule: "Cancel reset rule",
	selectStartSearchDate: "Please select a start date for the search",
	selectEndSearchDate: "Please select the end date of the search",
	startEarlyEnd: "The end time you choose is earlier than the start time",
	abandonDraftFail: "Abandon draft failed",
	attaDelFail: "Attachment deletion failed, please try again!",
	attaUploadFail: "Attachment upload failed",
	singleAtta50m: "A single attachment cannot exceed 50M!",
	sendSuccess: "Send Successfully",
	sendFail: "Send Failed",
	saveFail: "Save Failed",
	getMailDataFail: "Failed to get mail data",
	participantAddressFail: "The address of the participant with the error, please modify",
	recaiveAddressFail: "There is an incorrect receiving address, please modify",
	ccAddressFail: "There is an incorrect cc address, please modify",
	selectMeetStartDate: "Please select the meeting start date",
	selectMeetStartTime: "Please select the meeting start time",
	selectMeetEndDate: "Please select the meeting end date",
	selectMeetEndTime: "Please select the meeting end time",
	selectMeetRoom: "Please select the meeting room",
	addFavoriteContactSuc: "Add a favorite contact successfully",
	newGroupSuc: "Successfully created a new group",
	editGroupSuc: "Successfully edited the group",
	dataLoadErr: "Data Loading Error",
	cancelEdit: "Cancel Editing",
	operationSuc: "Operation Successful",
	operationFail: "Operation Failed",
	delFail: "Delete Failed",
	markSuc: "Mark Successfully",
	markFail: "Mark Failed",
	verifyCodeFail: "Incorrect verification code",
	createSuc: "Create Success",
	cancelled: "Cancelled",
	modifySuc: "Modified Success",
	clearSuc: "Successful Clearance",
	clearFail: "Emptying Failure",
	setSuc: "Setup Successfully",
	setFail: "Setup Failed",
	sureEmptyFolder: "Are you sure you want to empty the folders?",
	chooseDate: "Please choose the date",
	chooseTime: "Please choose the time",
	attaLoadFail: "Attachment Loading Failed",
	fillEmailSubject: "Please fill in the subject of the mail",
	sureDel: "Are you sure you want to delete it?",
	sureLogout: "Are you sure you want to log out?",
	doYouResetRule: "Do you reset the rules?",
	sureDissociateAccount: "Are you sure you want to dissociate the account?",
	whetherLoadAtta: "Do you load attachments?",
	sureDelGroup: "Are you sure you want to delete the group?",
	outsideEmailTips: "The following recipients are outside your organization",
	invalidMailboxAddress: "Invalid mailbox address",
	dupNameDelReentet: "The user has a duplicate name. Please delete it and re-enter it",
	subjectSenderLeastOne: "Subject and sender should fill in at least one item",
	downloadMessage: 'Cannot be downloaded from the corporate network',
	preview:'Preview',
  	creatorOperateTip:"You are the meeting creator, no action required",
	requestLimitTip:"Do not operate frequently",
	// 翻译
	selectTranslateLan: "Select translation language",
	translateEmail: "Translate email",
	translateing: "Translating...",
	translateFail: "Translation fail",
	showOrigin: "Display original text",
	showTranslate: "Display translation",
	translateTip: "The following content is translated by AI， just for reference"
}



// WEBPACK FOOTER //
// ./src/lang/en.js